itsoftApp.createModule("saveCookies", function () {
    const saveCookieButtons = document.querySelectorAll(".js-save-button");
    const cookies = document.querySelector(".js-cookies");
    const bodyEnd = document.querySelector(".js-padding-bottom");
    window.cookiesState = "inactive";

    const saveCookie = function (evt) {
        evt.preventDefault();

        const button = evt.currentTarget;

        if (button.hasAttribute("data-close")) {
            const plate = button.closest("[data-plate=" + button.getAttribute("data-close") + "]");

            plate && plate.classList.add("is-hidden");
        }

        itsoftApp.modules.cookie.setCookie(button);
        window.cookiesState = "inactive";
        bodyEnd.style.paddingBottom = 0;
    }

    if (saveCookieButtons.length > 0) {
        window.cookiesState = "active";
        bodyEnd.style.paddingBottom = cookies.getBoundingClientRect().height + "px";
        
        Array.prototype.forEach.call(saveCookieButtons, function (button) {
            button.addEventListener("click", saveCookie);
        });
    }
});